{
  "sube": {
    "Baslik": "Branch Introduction",
    "Ad": "Name",
    "Merkez": "Central?",
    "Durum": "Status",
    "Arama": "Search",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Yenile": "Refresh",
    "Data Yenile": "Refresh Data",
    "Ekle": "Add Branch",
    "Filtrele": "Filter",
    "Duzenle": "Edit",
    "Sil": "Delete",
    "Kaydet": "Save",
    "Guncelle": "Update",
    "Vazgec": "Cancel",
    "Latitude": "Latitude",
    "Longitude": "Longitude",
    "Şube Tanıtım": "Branch Introduction"
  }
}
